import React from 'react';
import { InlineWidget } from 'react-calendly';

function GetStarted() {
  const handleSubmit = (e) => {
    e.preventDefault();
    // ... existing form handling code ...
    
    // Track the lead submission
    window.trackLeadSubmission('get_started_form');
    
    // Track conversion
    window.trackFunnelEvent('form_submission', {
      'form_type': 'get_started'
    });
  }

  const handleInputChange = (e) => {
    // ... existing input handling code ...
    
    // Track form field engagement
    window.trackFunnelEvent('form_field_interaction', {
      'field_name': e.target.name
    });
  }

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-extrabold text-gray-900 text-center mb-8">
          Get Started: Schedule a Consultation for Your Corporate Event
        </h2>
        <p className="text-xl text-gray-600 text-center mb-12">
          Ready to elevate your next corporate gathering? Book a personalized consultation to discuss how Virgin Voyages can transform your meetings, incentive trips, or charter events. Our expert team will help you explore our unique venues, team-building activities, and customizable packages designed specifically for corporate groups.
        </p>
        <div className="bg-white rounded-lg shadow-xl p-6">
          <InlineWidget
            url="https://calendly.com/sean-revolutiontravel/30min"
            styles={{
              height: '700px'
            }}
            onEventScheduled={() => {
              // Google Analytics event tracking
              if (window.gtag) {
                window.gtag('event', 'appointment_booked', {
                  'event_category': 'Engagement',
                  'event_label': 'Corporate Consultation'
                });
              }
              // Facebook Pixel event tracking
              if (window.fbq) {
                window.fbq('track', 'ScheduleAppointment');
              }
            }}
          />
        </div>
      </div>
    </section>
  );
}

export default GetStarted;
